import React, { useState } from "react";
import { Modal, Form, Input, Button, Typography, Result, Alert } from "antd";
import { MailOutlined } from "@ant-design/icons";
import logoImg from "../../assets/logo/dealVoice.png";
import { requestPasswordReset } from "../../../services/authService";

const { Title, Paragraph, Text } = Typography;

function ForgotPwdModal({ isOpen, closeModals, openLogin }) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const onFinish = async (values) => {
    setError("");
    setLoading(true);
    try {
      const res = await requestPasswordReset(values.email);
      setSuccess(res.message || `A password reset link has been sent to ${values.email}`);
    } catch (err) {
      setError(err.message || "Failed to send reset email. Please verify your email address.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={isOpen} onCancel={closeModals} footer={null} centered width={440} styles={{ body: { padding: "2rem 1.5rem" } }}>
      <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
        <img src={logoImg} alt="DealVoice Logo" style={{ height: 36, objectFit: "contain" }} />
      </div>

      <Title level={3} style={{ textAlign: "center", margin: "0 0 0.5rem" }}>
        Reset password
      </Title>
      <Paragraph type="secondary" style={{ textAlign: "center", marginBottom: "1.5rem" }}>
        Enter your email and we'll send you a link to reset your password.
      </Paragraph>

      {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}

      {success ? (
        <Result
          status="success"
          title="Email Sent!"
          subTitle={success}
          extra={[
            <Button type="primary" key="ok" size="large" block onClick={closeModals}>
              Got it
            </Button>,
          ]}
        />
      ) : (
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Please enter a valid email" },
            ]}
          >
            <Input size="large" prefix={<MailOutlined style={{ color: "#94a3b8" }} />} placeholder="you@company.com" />
          </Form.Item>

          <Form.Item style={{ marginTop: 24 }}>
            <Button type="primary" htmlType="submit" size="large" block loading={loading} style={{ height: 44, borderRadius: 12, fontWeight: 600 }}>
              Send reset link
            </Button>
          </Form.Item>

          <div style={{ textAlign: "center" }}>
            <Text type="secondary">
              Remember your password?{" "}
              <Button
                type="link"
                style={{ padding: 0, fontWeight: 600 }}
                onClick={(e) => {
                  e.preventDefault();
                  openLogin();
                }}
              >
                Log In
              </Button>
            </Text>
          </div>
        </Form>
      )}
    </Modal>
  );
}

export default ForgotPwdModal;
